export class Image {
    id: number;
    parent_type: string;
    parent_id: number;
    image: string;
    sort_order: number;
    created_at: string;
    updated_at: string;
}


// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/shop/image.ts